import { useState } from 'react'
import { useSelector } from 'react-redux'
import { pdfPageMetaByPageNumberSelector } from 'apps/studio/store/selectors/pdfPageMeta'
import { SettingsNumberInput } from 'apps/studio/components/settings/inputs/SettingsNumberInput'
import { slugify } from 'apps/builder/lib/utils'

export const SettingsPositionGroup = ({
  data,
  update,
  inputs,
  label,
  labelAbove
}) => {
  const { position, page_number } = data
  const pageMeta = useSelector(pdfPageMetaByPageNumberSelector(page_number))
  const [errors, setErrors] = useState('')

  const className = `gcds--input-fields input--group${labelAbove ? ' label--above' : ''}`
  return (
    <div className={className}>
      <span className="input-fields__label">{label}</span>
      <div className="group--wrap">
        {inputs.map(({ label, ...inputConfig }) => {
          const settingId = `${slugify(label)}--position-group-input`

          return (
            <React.Fragment key={settingId}>
              <SettingsNumberInput
                id={settingId}
                {...inputConfig}
                data={{ ...position, page: pageMeta }}
                update={update}
                errorMsgHandler={setErrors}
                IconLeading={() => (
                  <svg
                    className="gcds--icon icon--svg label--inline"
                    viewBox="0 0 16 16"
                  >
                    <text
                      x="50%"
                      y="10"
                      fill="currentColor"
                      dominantBaseline="middle"
                      textAnchor="middle"
                    >
                      {label}
                    </text>
                  </svg>
                )}
              />
            </React.Fragment>
          )
        })}
        {errors && (
          <div className="field-error--wrap">
            <span className="field-error--message">{errors}</span>
          </div>
        )}
      </div>
    </div>
  )
}
